export const kioskDevicesResource = {
  name: '付款亭',
  fields: {
    id: 'ID',
    siteId: '場地',
    siteName: '場地',
    name: '名稱',
    status: '狀態',
    apiKeySuffix: 'API 金鑰',
    nearbyChargerIds: '附近充電機',
    octopusDeviceId: '八達通裝置編號',
    locationLabel: '位置',
    lastHeartbeatAt: '最後心跳',
    health: '健康狀態',
    appVersion: '應用程式版本',
    launcherVersion: '啟動器版本',
    updateState: '更新狀態',
    updateStateAt: '更新狀態起始',
    updateError: '更新錯誤',
    settlementDueSince: '待結算起始',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    maintenanceEnabled: '維護模式',
  },
  status: { pending: '待登記', active: '使用中', disabled: '已停用' },
  maintenance: {
    chip: '維護中',
    switchLabel: '維護模式',
    helperText: '開啟後此付款亭會停在維護畫面，直至關閉。進行中的充電不受影響。',
    enabled: '已開啟維護模式',
    disabled: '已關閉維護模式',
  },
  health: {
    reader: '八達通讀卡器', terminal: '刷卡終端機', printer: '打印機', paper: '紙張', clock: '時鐘',
    ok: '正常', absent: '未設定', error: '錯誤', low: '偏低', out: '缺紙', unknown: '未知',
    skewMs: '時鐘偏差 %{ms} 毫秒', offline: '離線', online: '在線', neverSeen: '從未連線',
  },
  sections: { basicInfo: '基本資料', hardware: '硬件', status: '狀態', settings: '設定', enrollment: '登記' },
  list: { subtitle: '自助充電付款亭及其健康狀態' },
  create: {
    title: '登記付款亭',
    subtitle: '建立付款亭記錄並取得一次性登記碼',
    siteHelperText: '只列出已開放付款亭的場地',
    nameHelperText: '顯示於管理後台及收據，例如「大堂付款亭」',
    nearbyChargersHelperText: '最接近此付款亭的充電機，會優先顯示',
    octopusDeviceIdHelperText: '可選。留空時登記後會自動填入讀卡器裝置編號',
    locationLabelHelperText: '付款亭所在位置，會顯示給領取八達通退款的司機，例如「B1 層，升降機大堂旁」（最多 80 字）',
  },
  edit: {
    title: '付款亭',
    issueCode: '發出新登記碼',
    issueCodeConfirm: '此操作會撤銷付款亭現有憑證，並把此付款亭尚未完成的八達通退款轉交客戶服務，必須以新登記碼重新登記。是否繼續？',
    codeIssued: '已發出登記碼',
    disable: '停用付款亭',
    enable: '啟用付款亭',
  },
  enrollment: {
    title: '登記碼',
    body: '請在付款亭輸入此登記碼。只會顯示一次，24 小時後失效。',
    expires: '%{when} 到期',
    copy: '複製登記碼',
    copied: '已複製',
    done: '完成',
  },
  update: {
    title: 'Update',
    targetVersion: 'Target version',
    waitingBecause: 'Waiting because',
    waitingNotBefore: 'Not before the rollout start',
    ocrlReleaseVersion: 'Octopus library release',
    idle: 'Up to date',
    retry: 'Retry update',
    retried: 'The update is offered again',
    retryRefused: {
      not_retryable: 'Only a failed or rolled back update can be retried.',
      rollout_not_active: 'Its rollout is paused or has ended. Resume a paused rollout first, or create a new rollout for this kiosk.',
    },
    restartApp: 'Restart app',
    restartPc: 'Restart PC',
    restartAppConfirm: 'The kiosk restarts the app as soon as nobody is using it and no payment is in progress. Charging is not affected.',
    restartPcConfirm: 'The kiosk restarts the PC as soon as nobody is using it and no payment is in progress. Charging is not affected. The kiosk is out of service for a few minutes.',
    restartRequested: 'Restart requested',
    restartPending: 'Restart requested %{time}; waits for an idle moment (expires after 24 hours)',
    restartPendingNoTime: 'Restart requested; waits for an idle moment (expires after 24 hours)',
    restartInProgress: 'Restart in progress',
    inTestGroup: 'In the test group',
    reader: 'Octopus reader',
    readerStates: { ready: 'Ready', connecting: 'Reconnecting', error: 'Error', stopped: 'Stopped', none: 'Not reported' },
    readerReported: 'Reported %{time}',
    readerNotReady: 'The Octopus reader is reconnecting. Restart now restarts without waiting for the reader. Wait for the reader restarts once it has reconnected. Either way the kiosk waits until nobody is using it and no payment is in progress.',
    restartNow: 'Restart now',
    waitForReader: 'Wait for the reader',
    pendingWaitsForReader: 'This restart also waits for the Octopus reader to reconnect.',
    retriesVersion: 'Retries %{version}.',
    releaseKey: 'Release key',
    releaseKeyNone: 'No release key pinned. This kiosk installs no updates until someone pins the key on its admin screen.',
    releaseKeyCurrent: '(current key)',
    releaseKeyOther: '(not the current key)',
    lastRestart: {
      title: 'Last restart',
      types: { restart: 'App restart', reboot: 'PC restart' },
      statuses: { pending: 'Waiting for an idle moment', in_progress: 'In progress', completed: 'Done', failed: 'Failed', cancelled: 'Cancelled', expired: 'Expired' },
      requested: 'Requested %{time}',
      closed: 'Closed %{time}',
      expired: 'The kiosk was never idle in the 24 hours after the request, so the restart did not happen.',
      reasons: {
        not_permitted: 'The launcher refused the restart because this kiosk is not set up to allow it.',
        launcher_unavailable: 'The launcher could not be reached, so the restart did not happen.',
        command_failed: 'The launcher ran the restart command and the command failed.',
      },
    },
  },
  settings: {
    title: '設定',
    key: '設定項目',
    value: '數值',
    source: '來源',
    authority: '權限',
    scope: { default: '預設', system: '系統', site: '場地', kiosk: '此付款亭' },
    authorityClass: { cloud: '管理後台', device: '裝置' },
    override: '為此付款亭覆寫',
    clear: '清除此付款亭覆寫',
    saved: '已儲存',
    cleared: '已清除',
    invalid: '數值無效',
    jsonHint: '請以 JSON 格式輸入（數字、true/false、"文字"、[清單] 或 {物件}）',
    kioskScopeNotAllowed: '由支援人員設定',
  },
  octopusClear: {
    title: '此付款亭的八達通已暫停',
    explain: '讀卡器已收到扣款指令，但在回覆前連線或電源中斷，付款亭無法確定客戶是否已被扣款。在您處理前，此付款亭會暫停八達通。',
    evidence: '處理前，請在付款亭電腦的讀卡器記錄（reader-logs 資料夾）及此讀卡器的八達通每日交易報表中查找每個收據號碼。',
    chargedFollowUp: '如讀卡器記錄或報表顯示已扣款，請以「已扣款」清除。應退款項隨後會在付款亭交易中顯示為「已過期：結果不明」。客戶服務為客戶退款後，請在該處把該記錄標記為已人手退款。',
    noBlocked: '付款亭沒有回報暫停的八達通付款。',
    receipt: '收據號碼 %{receipt}',
    transaction: '交易 %{id}',
    noTransaction: '沒有交易編號',
    waiting: '自 %{time} 起等待付款亭處理',
    stale: '付款亭在 24 小時內仍未處理於 %{time} 發出的清除指令。請取消或發出新的清除指令。',
    button: '清除暫停的八達通付款',
    confirm: '付款亭會把所選付款標記為由職員清除，並重新啟用八達通。付款亭會保留記錄。',
    finding: { not_charged: '未扣款：讀卡器記錄及報表均沒有此扣款', charged: '已扣款：讀卡器記錄或報表顯示此扣款' },
    status: { pending: '等待中', in_progress: '處理中', completed: '已完成', cancelled: '已取消', expired: '已過期' },
    note: '您查核的內容',
    noteHelper: '例如：2026-09-30 讀卡器記錄，此收據號碼沒有扣款',
    submit: '清除',
    sent: '已發送至付款亭',
    failed: '無法發送清除指令',
    cancel: '取消清除',
    cancelled: '已取消清除指令',
    notOpen: '此清除指令已不在等待中：付款亭已處理，或已被取消或過期',
    cancelFailed: '無法取消清除指令',
    loadFailed: '無法載入八達通清除記錄：%{_}',
    clearedRow: '已清除收據號碼 %{receipt}，HK$%{amount}',
    skipped: { not_found: '付款亭沒有付款 %{attempt}', not_blocked: '付款 %{attempt} 已不再暫停' },
  },
  printLog: {
    title: '收據打印記錄',
    columns: { time: '時間', slip: '單據', result: '結果', reason: '原因', receipt: '收據' },
    kind: { session_slip: '充電單', receipt: '收據', refund_incomplete: '退款未完成', test: '測試打印' },
    copy: '副本',
    outcome: { printed: '已打印', partly_printed: '部分已打印', not_printed: '未打印' },
    empty: '尚無打印記錄',
    loadMore: '載入更多',
    loadFailed: '無法載入打印記錄：%{error}',
  },
  printerDetail: {
    paper_low: '紙張不足',
    paper_out: '缺紙',
    cover_open: '機蓋打開',
    cutter_error: '切刀卡住',
    overheat: '打印頭過熱',
    mechanical_error: '打印頭壓桿抬起',
    unrecoverable_error: '打印機錯誤，請關機再開機',
    printer_error: '打印機錯誤',
    offline: '離線',
    not_answering: '沒有回應',
    not_found: 'USB 找不到打印機',
    ambiguous: '找到多於一部打印機，請設定 printer.address',
    transport_unsupported: '不支援此打印機連接方式',
    write_failed: '傳送到打印機失敗',
    write_timeout: '打印機未能及時接收單據',
    slip_failed: '無法製作單據',
    job_timeout: '打印機未能及時完成打印',
    printedLine: '打印機：%{detail}（檢查於 %{time}）',
  },
  readerPanel: {
    title: 'Octopus reader',
    noReport: 'No reader report yet',
    state: 'Reader state',
    deviceNumber: 'Device number',
    tat: 'TAT number',
    tatReported: 'Reported: %{value}',
    tatConfigured: 'Set in settings: %{value}',
    tatNotReported: 'not reported',
    tatNotSet: 'not set',
    logUpload: 'Log upload',
    logOk: 'OK',
    logFailing: 'Failing',
    timeZone: 'Clock time zone',
    timeZoneOk: 'OK (%{offset})',
    timeZoneWrong: 'Wrong (%{offset})',
    timeZoneNotReported: 'Not reported',
  },
  errors: {
    KIOSK_OCTOPUS_CLEAR_REFUSED: '付款亭未啟用、已有清除指令等待處理，或付款亭已不再回報此付款暫停',
    KIOSK_SITE_NOT_ENABLED: '請先在場地開放付款亭',
    KIOSK_NOT_FOUND: '找不到付款亭',
    KIOSK_SETTING_INVALID_VALUE: '此設定的數值無效',
    KIOSK_SETTING_SCOPE_NOT_ALLOWED: '此設定不可在此層級設定',
    KIOSK_QUOTE_TTL_BELOW_PAYMENT_WAIT: '報價有效時間必須至少為付款等候時間加 130 秒。',
  },
  lastSettlement: { label: 'Last settlement', none: 'No settlement yet', view: 'View settlements', outcomes: { ok: 'Settled', failed: 'Failed', interrupted: 'Interrupted' } },
};
export const kioskDevices = kioskDevicesResource;
